import { pathJoin } from 'src/reducers/routing/utils'

export const createContainersRouteMap = (prefix: string) => ({
  'ticket-details': pathJoin(prefix)('ticket-details').chain,
  'selected-containers': pathJoin(prefix)('selected-containers').chain,
})
